// material-ui
import { Button, Link, List, ListItem, ListItemText, Skeleton } from '@mui/material';

// project import
import MainCard from 'components/MainCard';
import { Notice } from 'components/Notice';
import React from 'react';
import { useNavigate } from 'react-router';
import { getRequest } from 'utils/apiRequest';
import { getUrlForPath } from 'utils/functions';


// ==============================|| SAMPLE PAGE ||============================== //
const HolidayNotice = () => {
    return (<Notice title="Domains">
        <p>A list of domains based on the client credentials found on the <Link href={getUrlForPath('/credentials')}>Credentials</Link> page.</p>
    </Notice>)
}
const HolidaysLoading = () => {
    return (<>
    <HolidayNotice />
            <MainCard title={"Domains"}>
            <List
                component="nav"
                sx={{
                    px: 0,
                    py: 0,
                }}
            >
                {Array(3).fill(0).map((n, i) => {
                    return (
                        <ListItem divider key={i}>
                            <ListItemText
                                primary={
                                    <Skeleton variant="text" width="40%" />
                                }
                                secondary={
                                    <>
                                        <Skeleton variant="text" width="40%" />
                                        <Skeleton variant="text" width="35%" />
                                        <Skeleton variant="text" width="45%" />
                                    </>
                                }
                            />
                        </ListItem>
                    )
                })}
            </List>
        </MainCard>
        </>)
}
const Holidays = () => {

    const [clients, setClients] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    const navigate = useNavigate();

    const getClientKeys = () => {
        setLoading(true)
        getRequest('/clients').then(data => {
            setClients(data);
        }).finally(() => {
            setLoading(false);
        })
    }
    React.useEffect(() => {
        getClientKeys();
    }, [])
    const handleConfiguration = (c) => {
        navigate("/holiday/settings/" + c.client_key);
    }
    if (loading) {
        return <HolidaysLoading />
    }
    return (<>
    <HolidayNotice />
        <MainCard title={"Domains"}>
            <List
                component="nav"
                sx={{
                    px: 0,
                    py: 0,
                }}
            >
                {clients.map((client, i) => {
                    return <ListItem divider key={i}>
                        <ListItemText
                                primary={client.domain}
                                secondary={client.client_key}
                            />
                        <Button onClick={() => handleConfiguration(client)} variant="outlined">Configure Holidays</Button>
                    </ListItem>
                })}
            </List>
        </MainCard>
        </>);
}

export default Holidays;
